// https://material.io/resources/icons/?icon=assignment&style=baseline
if (localStorage.active_user) {
  let ob = JSON.parse(localStorage.active_user);
  if (!ob) {
    localStorage.clear();
  }

  if (!ob.company_name && !ob.company) {
    localStorage.clear();
  }
}
